import React from 'react';
import * as RT from '@radix-ui/react-tooltip';

export function TooltipProvider({ children, delayDuration = 200 }) {
    return (
        <RT.Provider delayDuration={delayDuration} skipDelayDuration={300}>
            {children}
        </RT.Provider>
    );
}

export default function Tooltip({
    content,
    children,
    side = 'right',
    sideOffset = 8,
    align = 'center',
    disabled = false,
}) {
    if (!content || disabled) return children;
    return (
        <RT.Root>
            <RT.Trigger asChild>{children}</RT.Trigger>
            <RT.Portal>
                <RT.Content
                    side={side}
                    align={align}
                    sideOffset={sideOffset}
                    className="z-[9999] px-3 py-1 text-xs text-gray-900 bg-white rounded-lg shadow data-[state=delayed-open]:animate-in data-[state=closed]:animate-out"
                >
                    {content}
                </RT.Content>
            </RT.Portal>
        </RT.Root>
    );
}
